import React from 'react';

import type { HandleUpdateDyteConfiguration } from '~/components/SystemConfiguration/Communications/DyteVideoConfigurationTab/types';
import LinkShareTemplatesConfiguration from '~/components/SystemConfiguration/Communications/LinkShareTemplatesConfiguration';
import TEXTS from '~/components/SystemConfiguration/Communications/texts';

interface Props {
  handleUpdateConfiguration: HandleUpdateDyteConfiguration;
  emailTitleTemplate: string;
  emailBodyTemplate: string;
  smsTemplate: string;
}

const VideoGenericTemplatesConfiguration: React.FC<Props> = ({
  emailTitleTemplate,
  emailBodyTemplate,
  smsTemplate,
  handleUpdateConfiguration,
}) => (
  <LinkShareTemplatesConfiguration
    heading={TEXTS.videoCallTemplates.heading}
    subtitle={TEXTS.videoCallTemplates.subtitle}
    featureSpecific="video_calls"
    emailSectionTitle={TEXTS.videoCallTemplates.emailSectionTitle}
    smsSectionTitle={TEXTS.videoCallTemplates.smsSectionTitle}
    emailTitle={{ template: emailTitleTemplate }}
    emailBody={{ template: emailBodyTemplate }}
    sms={{ template: smsTemplate }}
    onSaveEmail={(values) =>
      handleUpdateConfiguration({
        email_title_template: values.title_template,
        email_body_template: values.body_template,
      })
    }
    onSaveSms={(values) => handleUpdateConfiguration({ sms_template: values.body_template })}
  />
);

export default VideoGenericTemplatesConfiguration;
